import {isEqualWith} from 'lodash';

import {ConversationBaseModel, ConversationModel} from '../../models/api/conversationModel';
import {createStabilizerCreator} from '../stabilityHelpers';

/*
 * Equality.
 */

const contentUpdatedDatesKey: keyof ConversationModel = 'contentUpdatedDates';

export function isConversationLightEqual<T extends ConversationBaseModel>(
  conversation: T | undefined,
  otherConversation: T | undefined,
): boolean {
  return isEqualWith(conversation, otherConversation, (value, otherValue, key, parent) => {
    if (!parent) {
      return undefined;
    }

    if (parent === conversation && key === contentUpdatedDatesKey) {
      return true;
    }

    return value === otherValue;
  });
}

export function areConversationsLightEqual<T extends ConversationBaseModel>(
  conversations: ReadonlyArray<T>,
  otherConversations: ReadonlyArray<T>,
): boolean {
  return isEqualWith(conversations, otherConversations, (value, otherValue, key, parent) => {
    if (!parent) {
      return undefined;
    }

    if (parent === conversations && typeof key === 'number') {
      return isConversationLightEqual(value, otherValue);
    }

    return value === otherValue;
  });
}

/*
 * Stabilizers.
 */

export const createConversationLightStabilizer = createStabilizerCreator<ConversationModel | undefined>(
  isConversationLightEqual,
);
export const createConversationsLightStabilizer =
  createStabilizerCreator<ReadonlyArray<ConversationModel>>(areConversationsLightEqual);

export const createConversationBaseLightStabilizer = createStabilizerCreator<
  ConversationBaseModel | undefined
>(isConversationLightEqual);
export const createConversationBasesLightStabilizer =
  createStabilizerCreator<ReadonlyArray<ConversationBaseModel>>(areConversationsLightEqual);
